import React from 'react';
import { IconProps } from './types';

export const ConvertIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M23 4V10H17' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.60015 18.4C3.30015 16 2.30015 12.4 3.50015 9C5.20015 4.3 10.3001 1.9 15.0001 3.5C16.3001 3.9 17.4001 4.7 18.4001 5.6L23.0001 10'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.5004 15C18.8004 19.7 13.7004 22.1 9.00041 20.5C4.30041 18.9 1.90041 13.7 3.50041 9C5.10041 4.3 10.3004 1.9 15.0004 3.5C16.3004 3.9 17.4004 4.7 18.4004 5.6L23.0004 10'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeDasharray='3 6'
      />
    </svg>
  );
};
